<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold">Patient Case Review</h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Symptoms of PH1 experienced by patient</h3>

            <ul class="list-disc pl-4 font-light">
                <li>
                    The patient is a 13-year-old boy who presented with abdominal pain,
                    <span class="font-semibold">nephrolithiasis</span>, and
                    <span class="font-semibold">nephrocalcinosis</span>, and had
                    <span class="font-semibold">a family history of kidney stones</span>
                    <ul class="list-inside list-['-_'] pl-6">
                        <li>
                            He began to have symptoms aged 2 years, with further investigations at 4 years, and was
                            diagnosed when aged 13 years, with an
                            <span class="font-semibold">11-year delay</span> between symptom onset and diagnosis
                        </li>
                    </ul>
                </li>
                <li>
                    After initial biochemical tests, ultrasound, and CT scans, his diagnosis of ESKD with a left kidney
                    stone led to the suspicion that <span class="font-semibold">PH1 was the underlying cause</span>,
                    which was confirmed by subsequent genetic testing
                </li>
            </ul>
        </div>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Patient journey</h3>

            <ul class="list-disc pl-4 font-light">
                <li>
                    Due to the years of missed follow-up (between the ages of 2–4 years and for a further 7 years prior
                    to presenting at the hospital in the study), the early symptoms of PH1 were overlooked
                </li>
                <li>By the time of diagnosis, the patient had ESKD</li>
            </ul>
        </div>

        <h3 class="text-base md:text-2xl font-semibold mb-3 p-6 bg-lightblue50 text-center">
            This case highlights the importance of suspecting PH1 for an early diagnosis when treating any patient
            presenting with nephrolithiasis or nephrocalcinosis, or patients with a family history or parenteral
            consanguinity. This case also highlights the importance of genetically testing siblings of PH1 patients.
        </h3>
    </div>
</template>
